import React from 'react'

const Title = (props)=>{
    return <h2 className="cinema-title">{props.title}</h2>
}

export default Title;